//节点类型枚举
export enum NodeTypeEnum {

    /// 开始节点
    InputNode = "input",

    //普通节点
    OrdinaryNode = "ordinaryNode",

    //会签节点
    CountersignNode = "countersignNode",

    //条件会签
    ConditionCountersignNode = "conditionCountersignNode",

    //决策节点
    DecisionNode = "decisionNode",

    //条件节点
    ConditionNode = "conditionNode",

    //任务节点
    TaskNode = "taskNode",

    /// 结束节点
    OutputNode = "output",

    //水平泳道节点
    SpLane = "spLane",

    //垂直泳道节点
    CzLane = "czLane",
}

//流程节点状态
export enum FlowNodeStateEnum {
    /// <summary>
    /// 未发布
    /// </summary>
    UnPublish = 0,

    /// <summary>
    /// 审核中
    /// </summary>
    InExamine = 1,

    /// <summary>
    /// 审核通过
    /// </summary>
    AuditPass = 2,

    /// <summary>
    /// 审核拒绝
    /// </summary>
    AuditRefuse = 3,

    /// <summary>
    /// 审核驳回
    /// </summary>
    AuditDismissal = 4,

    /// <summary>
    /// 归档
    /// </summary>
    Filing = 5,
}

//审核类型枚举
export enum AuditTypeEnum {

    //指定用户审核
    appointUser = 1,
    //指定角色审核
    appointRole = 2,
    //指定部门审核
    appointDepartment = 3,
    //指定岗位审核
    appointPost = 4,
}

/// <summary>
/// 过期动作
/// </summary>
export enum ExpireActionEnum {
    /// <summary>
    /// 自动批准
    /// </summary>
    Approve = 1,

    /// <summary>
    /// 驳回节点
    /// </summary>
    RejectNode = 2,

    /// <summary>
    /// 自动拒绝
    /// </summary>
    AuditRefuse = 3,

    /// <summary>
    /// 无动作
    /// </summary>
    NoAction = 99,
}

/// <summary>
/// 过期类型
/// </summary>
export enum ExpireTypeEnum {
    //天
    day = 1,

    /// 小时
    hour = 2,
}

//节点会签方式
export enum NodeCountersignWayEnum {
    /// <summary>
    /// 无
    /// </summary>
    None = 0,

    /// <summary>
    /// 全部审核人审批
    /// </summary>
    AllReviewerExamine = 1,

    /// <summary>
    /// 只需任意一人审批
    /// </summary>
    EitherReviewerExamine = 2,
}

//节点会签顺序
export enum NodeCountersignOrderEnum {
    /// <summary>
    /// 无
    /// </summary>
    None = 0,

    /// <summary>
    /// 按顺序审批
    /// </summary>
    OrderAsc = 1,

    /// <summary>
    /// 不按顺序审批
    /// </summary>
    NoOrder = 2,
}